<template lang="pug">

    .app-block

        // TYPES:

        //- text-block, title-block, lead-block, accent-note
        //- The most frequent
        //-
        div(v-if="isBasicHtml", :class="`${type} ${typeClasses}`")

            div(:class='`${type}__wrap`')

                div(v-if='needIlln', :class='`${type}__illn`')
                    photo(v-if="content.photo && content.photo.image", :object="content.photo", :base="base", :active='active')
                    video-hover(v-else-if="content['photo-hover'] && content['photo-hover'].image", :object="content['photo-hover']", :base="base")
                    illustration(v-else-if="content.illustration && content.illustration.image", :object="content.illustration", :base="base", :active='active')
                    object-three(v-else-if="content.object", :object="content.object", :base="base", :active='active')
                    decoration(v-else-if='content.decoration', :count='content.decoration.count', :active='active', :showLiteMode='false')

                div(:class='`${type}__content`')
                    h2.h2(:class='`${type}__title`', v-html="realTitle")
                    div(:class='`${type}__text`', v-html="text")



        //- title
        //-
        h2.title.h2(v-else-if="type === 'title'", :class="`${typeClasses} ${typeClass(content.types, 'h2--')}`", v-html="realTitle")


        //- accent-text
        //-
        .accent-text.accent-font(v-else-if="type === 'accent-text'", :class="typeClass(content.types, 'accent-font--')", v-html="text")


        //- quotes
        //-
        .quotes(v-else-if="type === 'quotes'", :class="typeClasses")

            .quotes__wrap

                .quotes__item(v-for="item in content.items")
                    .quotes__text(v-html="item.text ? item.text.join('') : ''", :data-decoration='content.types[0]')
                    .quotes__author(v-if="item.author", v-html="wrapTextSymbols(item.author, 2)")


        //- extra-story
        //-
        .extra-story-block(v-else-if="type === 'extra-story'")
            extra-story(:content="content", :active="active", :base="base", :isLiteMode='isLiteMode')

        //- youtube-player
        //-
        .youtube-player(v-else-if="type === 'youtube-player'", :class="typeClasses")
            .youtube-player__wrap
                .youtube-player__player
                    youtube(:video-id='content.ytid', ref='youtube', width='100%', height='100%')

        map-block(v-else-if="type === 'map'", :content="content", :active="active", :isLiteMode='isLiteMode')

        diagram-block(v-else-if="type === 'diagram'", :content="content", :active="active", :base="base", :isLiteMode='isLiteMode')

        authors(v-else-if="type === 'authors'", :active="active", :base="base", :decoration="content.decoration")

        next-block(v-else-if="type === 'next-block'", :content="content", :active="active")

        GoogleMapBlock(
            v-else-if="type === 'googlemap'",
            :active="active",
            :title="title",
            :share="share",
            :isLiteMode='isLiteMode'
            )

        ByRegionBlock(
            v-else-if="type === 'byregion'",
            :active="active",
            :title="title",
            :share="share"
            )

</template>

<script>
/* eslint-disable no-console */
/* Components */
import ExtraStory from './ExtraStory.vue';
import VideoHover from './illustrations/VideoHover.vue';
import Illustration from './illustrations/Illustration.vue';
import ObjectThree from './illustrations/ObjectThree.vue';
import Photo from './illustrations/Photo.vue';
import Decoration from '@/components/illustrations/Decoration.vue';
import MapBlock from './Map.vue';
import DiagramBlock from './Diagram.vue';
import GoogleMapBlock from './GoogleMap';
import {mapGetters} from 'vuex';
import ByRegionBlock from './ByRegion';
import Authors from './Authors.vue';
import NextBlock from './NextBlock.vue';

import Vue from 'vue';
import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

import inview from '../assets/js/vendors/element-inview';
import {InViewOffMixin} from '@/assets/js/viscom/viscomjs/utils/InViewOffMixin';
import {wrapHTMLSymbols} from '@/assets/js/viscom/viscomjs/utils/SplitText';

const startSymbol = ['&lt;/', '&lt;&lt;', '//', '/&lt;', '&lt;?/'];
const endSymbol = ['/&gt;', '//', '&gt;&gt;', '/&gt;', '/!&gt;'];

export default {
    name: 'app-block',

    props: {
        base: {
            type: String,
            default: ''
        },
        content: {
            default: () => {
                return {};
            },
            type: Object
        },
        index: {
            default: 0,
            type: Number
        },
        active: {
            default: false,
            type: Boolean
        }
    },

    components: {
        ExtraStory,
        Illustration,
        ObjectThree,
        Photo,
        VideoHover,
        MapBlock,
        GoogleMapBlock,
        DiagramBlock,
        ByRegionBlock,
        Decoration,
        Authors,
        NextBlock
    },

    data() {
        return {
            visible: false
        };
    },

    computed: {
        ...mapGetters('core', ['isLiteMode', 'shareMap']),

        type() {
            if (this.content.type === 'text') return 'text-block';
            return this.content.type;
        },

        title() {
            // if (this.type === 'title-block' || this.type === 'lead-block') return this.content.title || '';
            return this.content.title ? this.content.title : '';
        },

        realTitle() {
            // if (this.type === 'title-block' || this.type === 'lead-block') return this.content.title || '';
            return this.content.title ? this.titleHTML(this.content.title) : '';
        },

        isBasicHtml() {
            return (
                this.type === 'text-block' || this.type === 'title-block' || this.type === 'lead-block' || this.type === 'note' || this.type === 'accent-note'
            );

        },

        needIlln() {
            return this.type !== 'accent-note' && this.type !== 'note';
        },

        typeClasses() {
            const types = this.content.types;
            if (!types || types.length < 1) return;
            return types ? this.typeClass(types, this.type + '--') : '';
        },

        text() {
            return this.content.text ? this.content.text.join('') : '';
        },

        share() {
            return this.content.shareIndex ? this.shareMap[this.content.shareIndex] || null : null;
        }
    },

    mounted() {
        this.inviewObjs = [];

        if (this.active) this.restartInview();
    },

    beforeDestroy() {
        this.clearInviewRegistries();
    },

    watch: {
        active(to, from) {
            if (to === from) return;
            if (to) this.startInview();
            else this.clearInviewRegistries();
        },

        content() {
            if (this.active) this.restartInview();
        }
    },

    methods: {
        // ELEMENTS CONFIGURATION:

        // - COMMON

        typeClass(types, pre) {
            if (!types || !(types instanceof Array)) return '';
            return pre + types.join(` ${pre}`);
        },

        titleHTML(text) {
            if (!text) return '';

            // 1. Spanize
            const wrap = wrapHTMLSymbols(text, {
                cssProperty: 'transition',
                delay: 0,
                factor: 2,
                delayRatio: 0.4,
                delayMax: 0.08,
                delayMin: 0.03,
                durationRatio: 0.5,
                durationMax: 0.09,
                durationMin: 0.09,
                reverse: false,
                center: false,
                nestingNum: 1,
                applyTiming: true,
                flowType: 'container',
                timingNestingLevel: 0
            });
            let output = wrap.html;

            // 2. Remove line-wrap-root
            const i = output.indexOf('>');
            const pre = output.substring(0, i + 1);
            output = output.substring(i + 1, output.length - '</span>'.length);

            // 3. generate text decoration
            output = this.decorationText(output, text.length, wrap.delay);

            // 4. Add line-wrap-root
            output = `${pre}${output}</span>`;

            return output;
        },

        wrapTextSymbols(text) {
            // NO CLASSES!
            let s = text;
            if (s.substr(0, 3).toLowerCase() === '<p>') s = s.substr(3, text.length - 7);
            const arr = s.split('</p><p>');
            let config = {
                cssProperty: 'transition',
                delay: 0,
                factor: 2,
                delayRatio: 0.4,
                delayMax: 0.08,
                delayMin: 0.03,
                durationRatio: 0.5,
                durationMax: 0.09,
                durationMin: 0.09,
                reverse: false,
                center: false,
                nestingNum: 1,
                applyTiming: true,
                flowType: 'container',
                timingNestingLevel: 0
            };

            let i;
            s = '<p>';
            for (i = 0; i < arr.length; i++) {
                if (i !== 0) s += '</p><p>';
                s += wrapHTMLSymbols(arr[i], config).html;
            }
            s += '</p>';
            return s;
        },

        decorationText(text, length, delay) {
            if (!text) return '';
            const stS = startSymbol.shift();
            const endS = endSymbol.shift();
            startSymbol.push(stS);
            endSymbol.push(endS);

            let s = '<span class="symbol-wrap-root" style="transition-duration: 0.05s; transition-delay: 0.1s" aria-hidden="true">';
            s += stS;
            s += '</span>';
            s += text;
            s += `<span class="symbol-wrap-root" style="transition-duration: 0.05s; transition-delay: ${0.1 + delay}s" aria-hidden="true">`;
            s += endS;
            s += '</span>';
            return s;
        },

        restartInview() {
            this.clearInviewRegistries();
            this.startInview();
        },

        startInview() {
            if (this.realTitle.length > 0) this._startOneWayInview([...this.$el.querySelectorAll('.h2')]);

            if (this.isBasicHtml || this.type === 'accent-text') this._startOneWayInview([...this.$el.querySelectorAll('p')]);

            let sel = null;
            switch (this.type) {
                case 'accent-note':
                    sel = '.accent-note';
                    break;

                case 'extra-story':
                    sel = '.extra-story-block';
                    break;

                case 'quotes':
                    this._startOneWayInviewQuotes([...this.$el.querySelectorAll('.quotes')], '.quotes__author');
                    break;

                case 'authors':
                    this._startOneWayInview([this.$el.querySelector('.h3')]);
                    this._startOneWayInview([...this.$el.querySelectorAll('.author-list__item')]);
                    break;
            }
            if (sel) this._startOneWayInview([...this.$el.querySelectorAll(sel)]);
        },

        _startOneWayInview(els) {
            const inView = inview();
            inView.threshold(0.3);
            this.inviewObjs.push(
                //
                InViewOffMixin(
                    inView(els)
                        .on('enter', el => {
                            el.classList.add('entered');
                        })
                        .check()
                )
            );
        },

        _startOneWayInviewQuotes(els, innerSelector) {
            const inView = inview();
            inView.threshold(0.3);
            this.inviewObjs.push(
                //
                InViewOffMixin(
                    inView(els)
                        .on('enter', el => {
                            el.classList.add('entered');

                            let el2 = el.querySelector(innerSelector);
                            if (el2.dataset.hasInview) return;
                            el2.dataset.hasInview = true;
                            this._startOneWayInview(el2);
                        })
                        .check()
                )
            );
        },

        clearInviewRegistries() {
            while (this.inviewObjs.length > 0) {
                this.clearInviewRegistry(this.inviewObjs.pop());
            }
        },

        clearInviewRegistry(inviewRstry) {
            inviewRstry.removeAllListeners();
        }
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
//
.app-block {
    width: 100%;
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        margin-bottom: 2rem;
    }

    &:last-child {
        margin-bottom: 0;
    }

    &__group {
        padding: 0 0 1px;

        .app-block:last-child &:last-child {
            margin-bottom: 0;
        }

        &--group {
            &-outline {
                background-color: var(--color-outline-bg);
            }

            &-lite {
                background-color: var(--color-lite-bg);
            }

            &-lite,
            &-outline {
                padding-top: var(--width-column-grid);
                background-color: var(--color-outline-bg);
                margin-bottom: var(--width-column-grid);

                @media (--viewport-mobile), (--viewport-tablet-pt) {
                    padding-top: 2em;
                    margin-bottom: 2rem;
                }
            }
        }
    }

    &__group-wrap {
        max-width: var(--scr-max-width);
        padding: 0 var(--scr-padding-side);
        margin: 0 auto;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-left: 0;
            margin-right: 0;
            padding: 0;
        }
    }

    &__block {
        width: 100%;
    }
}
</style>
